import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { StaticQuery, graphql } from 'gatsby';

import Header from './Header';
import Footer from './Footer';

import mePhoto from '../images/me.jpg';
import ogImage from '../images/og-image.jpg';

const Layout = ({ children, scrollBlock }) => (
  <StaticQuery
    query={graphql`
      query LayoutQuery {
        social: allSocialYaml {
          edges {
            node {
              name
              icon
              url
            }
          }
        }
        config: site {
          siteMetadata {
            description
            fullName
            jobTitle
            keywords
            title
            urlLive
          }
        }
      }
    `}
    render={data => {
      const {
        description,
        fullName,
        jobTitle,
        keywords,
        title,
        urlLive,
      } = data.config.siteMetadata;

      const mePhotoURL = urlLive + mePhoto;
      const ogImageURL = urlLive + ogImage;
      const socialLinks = data.social.edges.map(el => `"${el.node.url}"`);
      const htmlOverflow = scrollBlock ? 'overflow: hidden !important' : null;

      return (
        <>
          <Helmet
            htmlAttributes={{ lang: 'en', style: htmlOverflow }}
            title={title}
            meta={[
              { name: 'description', content: description },
              { name: 'keywords', content: keywords },
              { property: 'og:description', content: description },
              { property: 'og:image', content: ogImageURL },
              { property: 'og:locale', content: 'en_US' },
              { property: 'og:title', content: title },
              { property: 'og:type', content: 'profile' },
              { property: 'og:url', content: urlLive },
              { property: 'profile:first_name', content: 'Luca' },
              { property: 'profile:gender', content: 'male' },
              { property: 'profile:last_name', content: 'Crea' },
              { property: 'twitter:card', content: 'summary_large_image' },
              { property: 'twitter:description', content: description },
              { property: 'twitter:image', content: ogImageURL },
              { property: 'twitter:site', content: '@Luca_Crea' },
              { property: 'twitter:title', content: title },
            ]}
            link={[
              {
                rel: 'stylesheet',
                crossorigin: 'anonymous',
                href:
                  'https://cdnjs.cloudflare.com/ajax/libs/bulma/0.7.2/css/bulma.min.css',
                integrity:
                  'sha256-2pUeJf+y0ltRPSbKOeJh09ipQFYxUdct5nTY6GAXswA=',
              },
              {
                rel: 'stylesheet',
                crossorigin: 'anonymous',
                href: 'https://use.fontawesome.com/releases/v5.5.0/css/all.css',
                integrity:
                  'sha384-B4dIYHKNBt8Bc12p+WXckhzcICo0wtJAoU8YZTY5qE0Id1GSseTk6S+L3BlXeVIU',
              },
            ]}
            script={[
              {
                type: 'application/ld+json',
                innerHTML: `
                  {
                    "@context": "http://schema.org/",
                    "@type": "Person",
                    "name": "${fullName}",
                    "description": "${description}",
                    "gender": "Male",
                    "image": "${mePhotoURL}",
                    "jobTitle": "${jobTitle}",
                    "url": "${urlLive}",
                    "sameAs": [${socialLinks}]
                  }
                `,
              },
            ]}
          />
          <Header fullName={fullName} jobTitle={jobTitle} />
          {children}
          <Footer icons={data.social.edges} />
        </>
      );
    }}
  />
);

Layout.propTypes = {
  children: PropTypes.node,
  scrollBlock: PropTypes.bool,
};

export default Layout;
